import './index.less'
import { Modal, Empty, Pagination } from 'antd'
import { useEffect, useState } from 'react';
import { cancelFollow, getMyFollowList } from '@/api/user'
import { useNavigate } from 'react-router-dom'


const MyCollect = () => {
  const [modal, contextHolder] = Modal.useModal();
  const navigate = useNavigate();
  const [followList, setFollowList] = useState([])
  const [pageNumber, setPageNumber] = useState(0)
  const [total, setTotal] = useState(0)
  const getData = (page:number) => {
    getMyFollowList({
      pageNumber: page,
      pageSize: 5
    }).then(res => {
      if (res?.code === 200) {
        setFollowList(res.result.records || []);
        setTotal(res.result.total);
        setPageNumber(res.result.current);
      }
    })
  }
  const paginationChange = (page: number) => {
    getData(page);
  };
  const handleCancelFollow = (id: string) => {
    modal.confirm({
      title: '提示',
      content: '确认取消关注吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async() => {
        const res = await cancelFollow(id)
        if (res.code === 200) {
          const list = [...followList];  
          const index = list.findIndex((item: any) => item.userId === id);
          list.splice(index, 1)
          setFollowList(list);
          setTotal(total - 1);
        }
      },
    });
  }
  useEffect(() => {
    getData(1)
  }, [])
  return <div className="my-follow">
    {contextHolder}
    <div className='my-follow-title'>我的关注</div>
    <div className='my-follow-main'>
      {
        followList.length === 0 ?  <div className='empty-content'>
          <Empty description="暂无关注" />
        </div> : null
      }
      {
        followList.map((item: any) => {
          return <div className='follow-item' key={item.userId}>
            <div className="avatar" onClick={() => navigate(`/user-detail/${item.userId}`)}>
              {item.avatar && <img src={item.avatar} alt="" />}
            </div>
            <div className="details">
              <span className="username" onClick={() => navigate(`/user-detail/${item.userId}`)}>{item.nickName || item.userName}</span>
              <div className="user-data">
                <span>{`问答 ${item.questionCount}`}</span>
                <span>{`关注 ${item.followingCount}`}</span>
                <span>{`粉丝 ${item.followerCount}`}</span>
              </div>
            </div>
            <span className="follow-btn" onClick={() => handleCancelFollow(item.userId)}>取消关注</span>
          </div>
        })
      }
      {
        total > followList.length && <Pagination
          pageSize={5}
          current={pageNumber}
          showSizeChanger={false}
          total={total}
          rootClassName="pagination"
          onChange={paginationChange}
        />
      }
    </div>
  </div>
}

export default MyCollect;